import { Wind, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Airco = () => {
  const heroImageUrl = "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773841092/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773841092717.jpg";

  const projectImages =[
    { 
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773789914/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773789914735.jpg", 
      alt: "Monteur legt leidingwerk aan op het dak" 
    },
    { 
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773789914/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773789914608.jpg", 
      alt: "Panasonic airco buitenunit aan de gevel" 
    },
    { 
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773789914/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773789913900.jpg", 
      alt: "Sinclair airco buitenunit" 
    },
    { 
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773789914/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773789914732.jpg", 
      alt: "Mooie houten omkasting voor airco buitenunit" 
    },
    { 
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773789913/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773789913826.jpg", 
      alt: "Overzicht Sinclair installatie" 
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773790099/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773790099270.jpg",
      alt: "Mitsubishi airco buitenunit gemonteerd boven pannendak"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773790099/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773790099279.jpg",
      alt: "Elegante donkere airco binnenunit boven een houten lattenwand"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773790099/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773790099368.jpg",
      alt: "Strakke zwarte airco binnenunit geïnstalleerd boven een raam"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773790099/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773790099592.jpg",
      alt: "Netjes afgewerkt leidingwerk langs een buitenmuur"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773790100/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773790099938.jpg",
      alt: "Airco buitenunit opstelling bij een houten schutting"
    }
  ];

  return (
    <div className="pt-24 pb-20">
      {/* Hero Section */}
      <div className="bg-gray-900 text-white py-20 mb-16">
        <div className="container mx-auto px-4 max-w-5xl text-center">
          <div className="inline-flex items-center justify-center p-4 bg-orange-600/20 rounded-2xl mb-6">
            <Wind className="h-12 w-12 text-orange-500" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Airconditioning Installatie</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
            Verkoelen in de zomer én energiezuinig verwarmen in de winter. Ontdek de mogelijkheden voor uw woning of bedrijf.
          </p>
          <Button asChild size="lg" className="bg-orange-600 hover:bg-orange-700 font-bold px-8">
            <Link to="/offerte">Vraag direct een offerte aan</Link>
          </Button>
        </div>
      </div>

      <div className="container mx-auto px-4 max-w-6xl">
        {/* Content Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-3xl font-bold mb-6">Meer dan alleen verkoeling</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Moderne aircosystemen zijn eigenlijk lucht-lucht warmtepompen. Ze zijn ideaal om uw slaapkamer koel te houden tijdens hete zomernachten, maar kunnen uw woonkamer ook zeer efficiënt (en snel) verwarmen in het voor- en najaar, waardoor u flink kunt besparen op uw gasrekening.
            </p>
            <ul className="space-y-4 mb-8">
              {[
                "Aangename temperatuur het hele jaar door",
                "Luchtzuivering (haalt pollen en stof uit de lucht)",
                "Fluisterstille binnen- en buitenunits",
                "Bediening via smartphone of tablet"
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle2 className="h-6 w-6 text-orange-500 shrink-0" />
                  <span className="text-gray-800 font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] md:aspect-square group">
            <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10" />
            <img 
              src={heroImageUrl} 
              alt="Airco binnenunit installatie op lattenwand" 
              className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" 
            />
          </div>
        </div>

        {/* Video Section */}
        <div className="mb-24 max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4">Bekijk ons werk in actie</h2>
            <p className="text-gray-600">Een korte impressie van een typische airco installatie.</p>
          </div>
          <div className="w-full aspect-video rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Ytz3MDRVsSo"
              title="SpiroTechniek Installatie Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Project Gallery */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Onze Airconditioning Projecten</h2>
            <p className="text-gray-600">Een greep uit onze recente installaties.</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {projectImages.map((img, i) => (
              <div key={i} className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer">
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300 z-10" />
                <img 
                  src={img.src} 
                  alt={img.alt} 
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" 
                />
                <div className="absolute bottom-0 left-0 w-full p-6 z-20 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                    {img.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="bg-orange-50 rounded-3xl p-12 text-center">
          <h2 className="text-3xl font-bold mb-4">Klaar voor een comfortabel klimaat?</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">Wij adviseren u graag over het juiste type airconditioning (single-split of multi-split) en de beste locatie voor de units.</p>
          <Button asChild size="lg" className="bg-orange-600 hover:bg-orange-700 text-white font-bold">
            <Link to="/offerte">Ontvang vrijblijvend advies <ArrowRight className="ml-2 h-5 w-5"/></Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Airco;
